import ExternalScriptLoader from 'components/Common/ExternalScriptLoader/ExternalScriptLoader';
import GoogleAnalyticsDataSender from 'components/Common/GoogleAnalyticsDataSender/GoogleAnalyticsDataSender';
import OpAlertNotification from 'components/Common/op-ui-wrappers/OpAlertNotification/OpAlertNotification';
import OPPlusWCToast from 'components/Common/OpPlusToast/OpPlusToast';
import PriceRefreshTicker from 'components/Common/PriceRefreshTicker/PriceRefreshTicker';
import TransferConfiguration from 'components/Common/TransferConfiguration/TransferConfiguration';
import WaitingForNetwork from 'components/Common/WaitingForNetwork/WaitingForNetwork';
import useIsServer from 'hooks/useIsServer';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { Switch, useLocation } from 'react-router-dom';
import composeRoutes from 'routes';
import getCategories from 'store/app/selector/getCategories';
import getOpRoutes from 'store/app/selector/getOpRoutes';
import './App.scss';
import OpPopup from './components/Common/op-ui-wrappers/OpPopup/OpPopup';

const App = () => {
  const categories = useSelector(getCategories);
  const opRoutes = useSelector(getOpRoutes);
  const isServer = useIsServer();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {!isServer && (
        <>
          <TransferConfiguration />
          <GoogleAnalyticsDataSender />
          <PriceRefreshTicker />
          <ExternalScriptLoader />
        </>
      )}
      <Switch>{renderRoutes(composeRoutes(categories, opRoutes))}</Switch>
      <WaitingForNetwork />
      <OPPlusWCToast />
      <OpAlertNotification />
    </>
  );
};

export default App;
